exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-alert[data-v-25abe1ae] {\n    width: 85%;\n}\n.v-alert .v-icon[data-v-25abe1ae] {\n    float: right;\n}\n", ""]);

